import { Button, ButtonProps, Intent } from '@blueprintjs/core'

import styles from './PrimaryButton.module.scss'

export default (props: ButtonProps & { alternative?: boolean }) => {
    const { alternative, ...buttonProps } = props
    return <>
        <Button
            {...buttonProps}
            intent={props.intent ?? (alternative ? Intent.WARNING : Intent.SUCCESS)}
            className={`${styles.button} ${alternative ? styles.alternative : styles.primary} ${props.className ?? ''}`}
            fill={props.fill ?? true} />
    </>
}